import { render } from "./Tree2Field.vue?vue&type=template&id=1a6816b2&scoped=true"
import script from "./Tree2Field.vue?vue&type=script&lang=js"
export * from "./Tree2Field.vue?vue&type=script&lang=js"

import "./Tree2Field.vue?vue&type=style&index=0&id=1a6816b2&lang=scss&scoped=true"

import exportComponent from "D:\\project\\php\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6816b2"]])

export default __exports__